(function (ws) {
    'use strict';

    ws.views.commentModal = ws.views.modal.extend({
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .crr-submit-comment': 'save',
            'keypress .crr-comment-box': 'resetCommentError'
        }),

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_activity',
        GTM_EVENT_ACTION: 'request_revision',

        /**
         * Initialize
         */
        initialize: function() {
            this.$commentInput = this.$('textarea.crr-comment-box');
            this.$queryError = this.$('.queryErrMsg');
            this.$form = this.$('form');
            this.$saveButton = this.$('.crr-submit-comment');
            this.$commentInput.val('');
            this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
            this.eventAgg.on('primaryQuoteModal', this.primaryQuoteModal.bind(this));
            ws.views.modal.prototype.initialize.call(this);
        },

        primaryQuoteModal: function (quoteId, versionId) {
            this.$('.newPrimaryQuote').val(quoteId);
            this.$('.newVersionID').val(versionId);
            this.eventAgg.trigger('crr-primaryQuoteModal');
        },

        save: function (e) {
            e.preventDefault();
            if ($.trim(this.$commentInput.val()).length === 0) {
                this.$queryError.show();
                this.$commentInput.addClass('error');
            } else {
                if (this.$form.hasClass('revisionModal')) {
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);

                    dataLayerAA.quote = {};
                    dataLayerAA.quote.id = this.$('.quoteID').val();
                    dataLayerAA.quote.type = $('.quote-type').text();
                    dataLayerAA.quote.date = $('.created-date').text();
                    _satellite.track('event:quote:requestRevision');
                }

                this.closeModal();
                globals.disableApp();
                this.$form.submit();
            }
        },

        /**
         * onOpen override - apart from opening the modal
         */
        onOpen: function () {
            this.$commentInput.val('');
            ws.views.modal.prototype.onOpen.call(this);
        },

        resetCommentError: function(e) {
            this.$commentInput.removeClass('error');
            this.$queryError.hide();
        }
    });
}(westcon));
